
const CustomizeCard = ({subtext,title,icon,btntext,bottomtext}) => {
    return (
        <div className="Card">
            <div className="Top_Box">
                <h4>{subtext}</h4>
                {/* <div className="Btn">
                    <img src={icon} alt="avatar" />
                    <h5>{btntext}</h5>
                </div> */}
            </div>
            <h2>{title}</h2>
            <span>{bottomtext}</span>
        </div>
    );
}
 
export default CustomizeCard;